import { render, staticRenderFns } from "./DeviceDataDialog.vue?vue&type=template&id=2f171023&scoped=true"
import script from "./DeviceDataDialog.vue?vue&type=script&lang=js"
export * from "./DeviceDataDialog.vue?vue&type=script&lang=js"
import style0 from "./DeviceDataDialog.vue?vue&type=style&index=0&id=2f171023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f171023",
  null
  
)

export default component.exports